export const widgetType = 'data-navigation'
